import { buildProps, definePropType } from '@zoryn/utils'
import { createCollectionWithScope } from '@zoryn/components/collection'

import type {
  ExtractPropTypes,
  ExtractPublicPropTypes,
  HTMLAttributes,
  StyleValue,
} from 'vue'

export const rovingFocusGroupProps = buildProps({
  style: {
    type: definePropType<StyleValue>([String, Array, Object, Boolean]),
    default: undefined,
  },
  currentTabId: {
    type: definePropType<string | null>(String),
  },
  defaultCurrentTabId: String,
  loop: Boolean,
  dir: {
    type: String, // left for direction support
    values: ['ltr', 'rtl'],
    default: 'ltr',
  },
  orientation: {
    // left for orientation support
    type: definePropType<HTMLAttributes['aria-orientation']>(String),
  },

  onBlur: Function,
  onFocus: Function,
  onMousedown: Function,
})

export type ZRovingFocusGroupProps = ExtractPropTypes<
  typeof rovingFocusGroupProps
>

export type ZRovingFocusGroupPropsPublic = ExtractPublicPropTypes<
  typeof rovingFocusGroupProps
>

const {
  ZCollection,
  ZCollectionItem,
  COLLECTION_INJECTION_KEY,
  COLLECTION_ITEM_INJECTION_KEY,
} = createCollectionWithScope('RovingFocusGroup')

export {
  ZCollection,
  ZCollectionItem,
  COLLECTION_INJECTION_KEY as ROVING_FOCUS_COLLECTION_INJECTION_KEY,
  COLLECTION_ITEM_INJECTION_KEY as ROVING_FOCUS_ITEM_COLLECTION_INJECTION_KEY,
}
